/* ============================================================
   THREE PINES ROOFING — THEME JS v2.1
   Cafe Racer · Classic Americana · Aspirational Luxury

   NOTE: The multi-step funnel form and Lead Command CRM
   integration are handled entirely by the inline <script>
   inside sections/funnel-home.liquid. Do NOT add a second
   funnel controller here — it will cause double-fire on every
   button click and spam the Lead Command API with duplicate
   slot requests and lead submissions.
   ============================================================ */

(function() {
  'use strict';

  /* ── Header Scroll Effect ── */
  const header = document.querySelector('.tp-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('tp-header--scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Hero BG Ken Burns ── */
  const heroBg = document.querySelector('.tp-hero__bg');
  if (heroBg) {
    setTimeout(() => heroBg.classList.add('loaded'), 100);
  }

  /* ── Sticky CTA Bar ── */
  const stickyCta = document.querySelector('.tp-sticky-cta');
  if (stickyCta) {
    const heroSection = document.querySelector('.tp-hero');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        stickyCta.classList.toggle('visible', !e.isIntersecting);
      });
    }, { threshold: 0.1 });
    if (heroSection) observer.observe(heroSection);
  }

  /* ── Fade-Up Animations ── */
  const fadeEls = document.querySelectorAll('.tp-fade-up');
  if (fadeEls.length) {
    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, (entry.target.dataset.delay || 0) * 1);
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach((el, i) => {
      el.dataset.delay = i * 80;
      fadeObserver.observe(el);
    });
  }

  /* ── Smooth Scroll (hash links only) ── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* ── Mobile Nav Toggle ── */
  document.querySelectorAll('.tp-mobile-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const mobileNav = document.querySelector('.tp-mobile-nav');
      if (!mobileNav) return;
      const open = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
  });

  /* ── Counter Animation ── */
  const counters = document.querySelectorAll('[data-count]');
  if (counters.length) {
    const countObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseInt(el.dataset.count, 10);
          const suffix = el.dataset.suffix || '';
          const duration = 1800;
          const start = performance.now();
          const animate = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(eased * target) + suffix;
            if (progress < 1) requestAnimationFrame(animate);
          };
          requestAnimationFrame(animate);
          countObserver.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(c => countObserver.observe(c));
  }

})();
